import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, ArrowRight, Anchor, Truck, Plane } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_logistics-rajkot/artifacts/ry4xgme6_image.png";

const quickLinks = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },
  { name: "Our Services", path: "/services" },
  { name: "Gallery", path: "/gallery" },
  { name: "Contact Us", path: "/contact" },
];

const services = [
  "In-Land Transportation",
  "Customs Clearance",
  "Ocean Freight",
  "Air Freight",
  "Warehousing & Storage",
  "Import & Export Cargo",
];

export default function Footer() {
  return (
    <footer className="bg-[#0F172A] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main footer */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6" data-testid="footer-logo">
              <img src={LOGO_URL} alt="Pranav Logistics" className="h-14 w-auto" />
              <div>
                <div className="font-['Barlow_Condensed'] font-bold text-white text-lg leading-tight">PRANAV</div>
                <div className="font-['Barlow_Condensed'] text-[#0EA5E9] text-xs font-semibold tracking-widest">LOGISTICS</div>
              </div>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Delivering seamless cargo solutions with 18+ years of industry experience. Your reliable logistics partner from skyline to shoreline.
            </p>
            <div className="flex items-center gap-3 text-slate-500">
              <Truck size={20} strokeWidth={1.5} />
              <Anchor size={20} strokeWidth={1.5} />
              <Plane size={20} strokeWidth={1.5} />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-['Barlow_Condensed'] font-bold text-lg mb-6 text-white">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="footer-link text-slate-400 text-sm flex items-center gap-2 hover:text-[#F97316]"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    <ArrowRight size={14} strokeWidth={1.5} />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-['Barlow_Condensed'] font-bold text-lg mb-6 text-white">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <Link
                    to="/services"
                    className="footer-link text-slate-400 text-sm flex items-center gap-2 hover:text-[#F97316]"
                  >
                    <ArrowRight size={14} strokeWidth={1.5} />
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-['Barlow_Condensed'] font-bold text-lg mb-6 text-white">Contact Info</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin size={18} strokeWidth={1.5} className="text-[#F97316] mt-1 flex-shrink-0" />
                <a
                  href="https://www.google.com/maps/search/1317,+150+Feet+Ring+Rd,+Sheetal+Park,+Shastri+Nagar,+Rajkot,+Gujarat+360007"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 text-sm leading-relaxed hover:text-[#F97316] transition-colors"
                  data-testid="footer-address-link"
                >
                  OFFICE NO 1009, 10th Floor, RK World Tower, Near Shital Park, Rajkot – 360006, Gujarat, India
                </a>
              </div>
              <a
                href="tel:+917575873232"
                className="flex items-center gap-3 text-slate-400 text-sm hover:text-[#F97316] transition-colors"
                data-testid="footer-phone"
              >
                <Phone size={18} strokeWidth={1.5} className="text-[#F97316] flex-shrink-0" />
                +91 75758 73232
              </a>
              <a
                href="mailto:info@pranavlogistics.com?subject=Inquiry%20-%20Pranav%20Logistics"
                className="flex items-center gap-3 text-slate-400 text-sm hover:text-[#F97316] transition-colors"
                data-testid="footer-email"
              >
                <Mail size={18} strokeWidth={1.5} className="text-[#F97316] flex-shrink-0" />
                info@pranavlogistics.com
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-slate-800 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            &copy; {new Date().getFullYear()} Pranav Logistics. All rights reserved.
          </p>
          <p className="text-slate-600 text-xs">
            Reliable Logistics Partner Delivering Seamless Cargo Solutions
          </p>
        </div>
      </div>
    </footer>
  );
}
